import { getI18n } from '@vxe-ui/core';
export const getFormDesignWidgetName = (name) => {
    return getI18n(`vxe.formDesign.widget.component.${name}`);
};
export const handleGetFormDesignWidgetName = (params) => {
    return getFormDesignWidgetName(params.name);
};
